// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Products from './pages/Products';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import BlogDetail from './pages/BlogDetail';

// Service pages
import PlanningScheduling from './pages/services/PlanningScheduling';
import ScheduleRiskAnalysis from './pages/services/ScheduleRiskAnalysis';
import TimeChainage from './pages/services/TimeChainage';
import Report from './pages/services/Report';
import Training from './pages/services/Training';

import LegalPage from './pages/LegalPage';
import { PrivacyProvider } from './context/PrivacyContext';
import CookieBanner from './components/CookieBanner';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <PrivacyProvider>
        <ScrollToTop /> 
        <CookieBanner />
        <div className="d-flex flex-column min-vh-100">
          <Navbar />
          <main className="flex-grow-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/products" element={<Products />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/contact" element={<Contact />} />
              
              <Route path="/services/PlanningScheduling/" element={<PlanningScheduling />} />
              <Route path="/services/ScheduleRiskAnalysis/" element={<ScheduleRiskAnalysis />} />
              <Route path="/services/TimeChainage/" element={<TimeChainage />} />
              <Route path="/services/Training/" element={<Training />} />
              <Route path="/services/Report/" element={<Report />} />
             <Route path="/legal/:slug" element={<LegalPage />} />
              <Route path="/blog/:id" element={<BlogDetail />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </PrivacyProvider>
    </Router>
  );
}

export default App;